export const MARKET_ROUTING = [
    {
        id: `3140`,
        name: `Portland, ME`,
        url: `/markets-map/portland-me`,
    },
    {
        id: `3137`,
        name: `New York, NY`,
        url: `/markets-map/new-york-ny`,
    },
    {
        id: `3110`,
        name: `Binghamton, NY`,
        url: `/markets-map/binghamton-ny`,
    },
    {
        id: `3115`,
        name: `Cleveland, OH`,
        url: `/markets-map/cleveland-akron-canton-oh`,
    },
    {
        id: `259`,
        name: `Flint/Saginaw Bay, MI`,
        url: `/markets-map/flint-saginaw-bay-city-mi`,
    },
    {
        id: `3112`,
        name: `Buffalo, NY`,
        url: `/markets-map/buffalo-ny`,
    },
    {
        id: `3111`,
        name: `Cincinnati, OH`,
        url: `/markets-map/cincinnati-oh`,
    },
    {
        id: `3122`,
        name: `Erie, PA`,
        url: `/markets-map/erie-pa`,
    },
    {
        id: `272`,
        name: `Charlotte, NC`,
        url: `/markets-map/charlotte-nc`,
    },
    {
        id: `3126`,
        name: `Greensboro, NC`,
        url: `/markets-map/greensboro-high-point-winston-salem`,
    },
    {
        id: `3148`,
        name: `Utica, NY`,
        url: `/markets-map/utica-ny`,
    },
    {
        id: `3135`,
        name: `Louisville, KY`,
        url: `/markets-map/louisville-ky`,
    },
    {
        id: `280`,
        name: `Tri-Cities, TN/VA`,
        url: `/markets-map/tri-cities-tn-va`,
    },
    {
        id: `3105`,
        name: `Albany, NY`,
        url: `/markets-map/albany-schenectady-troy-ny`,
    },
    {
        id: `3389`,
        name: `Orlando, FL`,
        url: `/markets-map/orlando-fl`,
    },
    {
        id: `3116`,
        name: `Columbus, OH`,
        url: `/markets-map/columbus-oh`,
    },
    {
        id: `3152`,
        name: `Youngstown, OH`,
        url: `/markets-map/youngstown-oh`,
    },
    {
        id: `3109`,
        name: `Bangor, ME`,
        url: `/markets-map/bangor-me`,
    },
    {
        id: `3143`,
        name: `Rochester, NY`,
        url: `/markets-map/rochester-ny`,
    },
    {
        id: `3397`,
        name: `Tampa, FL`,
        url: `/markets-map/tampa-stpetersburg-fl`,
    },
    {
        id: `269`,
        name: `Traverse City-Cadillac, MI`,
        url: `/markets-map/traverse-city-cadillac-mi`,
    },
    {
        id: `3131`,
        name: `Lexington, KY`,
        url: `/markets-map/lexington-ky`,
    },
    {
        id: `3119`,
        name: `Dayton, OH`,
        url: `/markets-map/dayton-oh`,
    },
    {
        id: `3312`,
        name: `Norfolk, VA`,
        url: `/markets-map/norfolk-va`,
    },
    {
        id: `3125`,
        name: `Greenville, NC`,
        url: `/markets-map/greenville-new-bern-washington-nc`,
    },
    {
        id: `3106`,
        name: `Columbia, SC`,
        url: `/markets-map/columbia-sc`,
    },
    {
        id: `3147`,
        name: `Toledo, OH`,
        url: `/markets-map/toledo-oh`,
    },
    {
        id: `3150`,
        name: `Watertown, NY`,
        url: `/markets-map/watertown-ny`,
    },
    {
        id: `3151`,
        name: `Wilmington, NC`,
        url: `/markets-map/wilmington-nc`,
    },
    {
        id: `3141`,
        name: `Presque Isle, ME`,
        url: `/markets-map/presque-isle-me`,
    },
    {
        id: `264`,
        name: `Marquette, MI`,
        url: `/markets-map/marquette-mi`,
    },
    {
        id: `3146`,
        name: `Syracuse, NY`,
        url: `/markets-map/syracuse-ny`,
    },
    {
        id: `3132`,
        name: `Lima, OH`,
        url: `/markets-map/lima-oh`,
    },
    {
        id: `3142`,
        name: `Raleigh-Durham, NC`,
        url: `/markets-map/raleigh-durham-nc`,
    },
    {
        id: `3121`,
        name: `Elmira, NY`,
        url: `/markets-map/elmira-corning-ny`,
    },
    {
        id: `273`,
        name: `Greenville / Spartanburg / Asheville`,
        url: `/markets-map/greenville-spartanburg-sc-asheville-nc-anderson-sc`,
    },
    {
        id: `3123`,
        name: `Myrtle Beach-Florence, SC`,
        url: `/markets-map/myrtle-beach-florence-sc`,
    },
    {
        id: `581`,
        name: `Terre Haute, IN`,
        url: `/markets-map/terre-haute`,
    },
    {
        id: `257`,
        name: `Alpena, MI`,
        url: `/markets-map/alpena-mi`,
    },
    {
        id: `3154`,
        name: `Zanesville, OH`,
        url: `/markets-map/zanesville-oh`,
    },
    {
        id: `3117`,
        name: `Corpus Christi, TX`,
        url: `/markets-map/corpus-christi-tx`,
    },
    {
        id: `814`,
        name: `St. Louis, MO`,
        url: `/markets-map/st-louis-mo`,
    },
    {
        id: `610`,
        name: `Rockford, IL`,
        url: `/markets-map/rockford-il`,
    },
    {
        id: `267`,
        name: `Roch/Mason/Austin, MN`,
        url: `/markets-map/rochmas-ctyaus-mn`,
    },
    {
        id: `3129`,
        name: `Kansas City, MO`,
        url: `/markets-map/kansas-city-mo`,
    },
    {
        id: `265`,
        name: `Milwaukee, WI`,
        url: `/markets-map/milwaukee-wi`,
    },
    {
        id: `3118`,
        name: `Dallas / Ft. Worth, TX`,
        url: `/markets-map/dallas-ftworth-tx`,
    },
    {
        id: `3149`,
        name: `Waco, TX`,
        url: `/markets-map/waco-tx`,
    },
    {
        id: `271`,
        name: `Birmingham, AL`,
        url: `/markets-map/birmingham-anniston-tuscaloosa-al`,
    },
    {
        id: `249`,
        name: `Paducah / Cape Girardeau`,
        url: `/markets-map/paducah-ky-cape-girardeau-mo`,
    },
    {
        id: `3107`,
        name: `Austin, TX`,
        url: `/markets-map/austin-tx`,
    },
    {
        id: `3127`,
        name: `Harlingen, TX`,
        url: `/markets-map/harlingen-weslaco-brownsville-mcallen-tx`,
    },
    {
        id: `638`,
        name: `St. Joseph, MO`,
        url: `/markets-map/st-joesph-mo`,
    },
    {
        id: `3144`,
        name: `San Antonio TX`,
        url: `/markets-map/san-antonio-tx`,
    },
    {
        id: `649`,
        name: `Evansville, IN`,
        url: `/markets-map/evansville`,
    },
    {
        id: `248`,
        name: `Omaha, NE`,
        url: `/markets-map/omaha-ne`,
    },
    {
        id: `3124`,
        name: `Green Bay, WI`,
        url: `/markets-map/green-bay-appleton-wi`,
    },
    {
        id: `262`,
        name: `Madison, WI`,
        url: `/markets-map/madison-wi`,
    },
    {
        id: `258`,
        name: `Duluth / Superior`,
        url: `/markets-map/duluth-mn-superior-wi`,
    },
    {
        id: `275`,
        name: `Huntsville / Decatur, AL`,
        url: `/markets-map/huntsville-decatur-florence-al`,
    },
    {
        id: `277`,
        name: `Montgomery, AL`,
        url: `/markets-map/montgomery-al`,
    },
    {
        id: `261`,
        name: `La Crosse, WI`,
        url: `/markets-map/la-crosse-eau-claire-wi`,
    },
    {
        id: `270`,
        name: `Wausau/Rhinelander, WI`,
        url: `/markets-map/wausau-rhinelander-wi`,
    },
    {
        id: `250`,
        name: `Quincy/Hannibal, MO`,
        url: `/markets-map/quincy-il-hannibal-mo`,
    },
    {
        id: `244`,
        name: `Lincoln / Hastings / Kearney, NE`,
        url: `/markets-map/lincoln-hastings-kearney-ne`,
    },
    {
        id: `263`,
        name: `Mankato, MN`,
        url: `/markets-map/mankato-mn`,
    },
    {
        id: `247`,
        name: `North Platte, NE`,
        url: `/markets-map/north-platte-ne`,
    },
    {
        id: `3128`,
        name: `Honolulu, HI`,
        url: `/markets-map/honolulu-kahului-lihue-hilo-hi`,
    },
    {
        id: `3130`,
        name: `Laredo, TX`,
        url: `/markets-map/laredo-tx`,
    },
    {
        id: `235`,
        name: `Butte, MT`,
        url: `/markets-map/butte-bozeman-mt`,
    },
    {
        id: `241`,
        name: `Great Falls, MT`,
        url: `/markets-map/great-falls-mt`,
    },
    {
        id: `234`,
        name: `Billings, MT`,
        url: `/markets-map/billings-mt`,
    },
    {
        id: `243`,
        name: `Idaho Falls / Pocatello / Jackson`,
        url: `/markets-map/idaho-falls-pocatello-idjackson-wy`,
    },
    {
        id: `237`,
        name: `Cheyenne / Scottsbluff`,
        url: `/markets-map/cheyenne-wy-scottsbluff-ne`,
    },
    {
        id: `246`,
        name: `Missoula, MT`,
        url: `/markets-map/kalispell-missoula-mt`,
    },
    {
        id: `764`,
        name: `Rapid City, SD`,
        url: `/markets-map/rapid-city-sd`,
    },
    {
        id: `3120`,
        name: `El Paso, TX`,
        url: `/markets-map/el-paso-tx-las-cruces-nm`,
    },
    {
        id: `242`,
        name: `Helena, MT`,
        url: `/markets-map/helena-mt`,
    },
    {
        id: `236`,
        name: `Casper / Riverton, WY`,
        url: `/markets-map/casper-riverton-wy`,
    },
    {
        id: `3156`,
        name: `Yuma, AZ`,
        url: `/markets-map/yuma-az-el-centro-ca`,
    },
    {
        id: `240`,
        name: `Grand Junction, CO`,
        url: `/markets-map/grand-junction-montrose-co`,
    },
    {
        id: `3407`,
        name: `Bakersfield, CA`,
        url: `/markets-map/bakersfield-ca`,
    },
    {
        id: `3134`,
        name: `Los Angeles, CA`,
        url: `/markets-map/los-angeles-ca`,
    },
    {
        id: `3139`,
        name: `Palm Springs, CA`,
        url: `/markets-map/palm-springs-ca`,
    },
    {
        id: `256`,
        name: `Yakima, WA`,
        url: `/markets-map/yuma-az-el-centro-ca`,
    },
    {
        id: `252`,
        name: `Reno, NV`,
        url: `/markets-map/reno-nv`,
    },
    {
        id: `245`,
        name: `Medford/Klamath Falls, OR`,
        url: `/markets-map/medford-klamath-falls-or`,
    },
    {
        id: `253`,
        name: `Santa Barbara, CA`,
        url: `/markets-map/santa-barbara-san-luis-obispo-ca`,
    },
    {
        id: `238`,
        name: `Chico / Redding, CA`,
        url: `/markets-map/chico-redding-ca`,
    },
];
